/* eslint-disable */
/* eslint-disable */
import { grey } from '@material-ui/core/colors';

const chipSelectorStyles = ({ theme }) => ({
  loading: {
    height: `${theme.spacing(1) * 2.5}px !important`,
    width: `${theme.spacing(1) * 2.5}px !important`,
    marginRight: theme.spacing(1) * 0.5,
  },
  menuListRoot: {
    maxHeight: 200,
    flexWrap: `wrap`,
    overflow: `auto`,
    paddingTop: theme.spacing(1) * 1,
    boxShadow: `0px 0px 3px #909090`,
  },
  listSubheader: {
    top: -theme.spacing(1) * 1,
    backgroundColor: theme.palette.background.paper,
    borderBottom: `${grey[300]} 1px solid`,
  },
  menuItemRoot: {
    height: `auto`,
    padding: theme.spacing(1) * 1,
    paddingLeft: theme.spacing(1) * 2,
    paddingRight: theme.spacing(1) * 2,
  },
  menuItemContent: {
    width: `100%`,
    display: `block`,
  },
  paperRoot: {
    position: `absolute`,
    zIndex: 9999999999999999,
    width: `100%`,
    flexWrap: `nowrap`,
    backgroundColor: `#fff`,
    borderRadius: `0 0 4px 4px`,
    marginTop: -1,
  },
  mainContainer: {
    position: `relative`,
  },
  icon: {
    opacity: 0.5,
    height: `${theme.spacing(1) * 3}px !important`,
    width: `${theme.spacing(1) * 3}px !important`,
  },
});

export default chipSelectorStyles;
